<template>
    <div class="overflow-wrapper">
        <div class="cols margin-bottom-20" style="gap: 10px;">
            <button @click="edit(-1)">Nový záznam</button>
            <button @click="exportTable">Export</button>
            <button v-if="this.menuItem === 6 && (this.isAdmin || this.isEditor)" @click="mergePracoviste" :class="!this.mergePrac ? 'button-inverse padding-button-inverse' : ''" style="margin-left: 40px;">Sloučení pracovišť</button>
        </div>

        <div style="display: flex; align-items: flex-start;">
            <EditTypDOSS
                v-if="showEdit && menuItem === 4"
                :itemId="itemId"
                @close="closeEdit"
                @updateTable="updateTable"
                class="margin-bottom-20 border padding-10"
            />
            
            <EditDOSS
                v-if="showEdit && menuItem === 5"
                :itemId="itemId"
                @close="closeEdit"
                @updateTable="updateTable"
                class="margin-bottom-20 border padding-10"
            />
            
            <EditDOSSPrac
                v-if="showEdit && menuItem === 6"
                :itemId="itemId"
                @close="closeEdit"
                @updateTable="updateTable"
                class="margin-bottom-20 border padding-10"
            />
            
            <EditDruhPodani
                v-if="showEdit && menuItem === 7"
                :itemId="itemId"
                @close="closeEdit"
                @updateTable="updateTable"
                class="margin-bottom-20 border padding-10"
            />
            
            <EditDruhStanoviska
                v-if="showEdit && menuItem === 8"
                :itemId="itemId"
                @close="closeEdit"
                @updateTable="updateTable"
                class="margin-bottom-20 border padding-10"
            />
            
            <EditStatus
                v-if="showEdit && menuItem === 9"
                :itemId="itemId"
                @close="closeEdit"
                @updateTable="updateTable"
                class="margin-bottom-20 border padding-10"
            />
        </div>

        <div v-if="this.menuItem === 6 && this.mergePrac">
            <span style="color: red;">Vyberte pracoviště ke sloučení a kliknětě na tlačítko</span>
            <button @click="showMerge" class="button-small" style="margin-left: 10px;">Potvrdit</button>
        </div>

        <div class="overflow-container" style="margin-top: 20px;">
            <div v-if="this.menuItem === 6" style="margin-bottom: 10px;">
                Filtr:
                <select v-model="this.idTypDOSS" style="width: 360px;">
                    <option :value="-1">&lt; vyberte typ instituce &gt;</option>
                    <option v-for="(d, i) in sortedTypDOSS" :key="i" :value="d.id">{{ d.kategorie + ' - ' + d.nazev }}</option>
                </select>
                <select v-model="this.idDOSS" style="width: 360px; margin-left: 5px;">
                    <option :value="-1">&lt; vyberte instituci &gt;</option>
                    <option v-for="(d, i) in sortedDOSS" :key="i" :value="d.id">{{ d.kategorie + ' - ' + d.nazev }}</option>
                </select>
            </div>

            <div>
                <table>
                    <thead>
                        <tr>
                            <th v-if="this.menuItem === 6 && this.mergePrac">
                            </th>

                            <th v-for="(v, k) in headers" :key="k" @click="sort(k)">{{ v }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, i) in sortedRows" :key="i" @click="edit(row['id'])">
                            <td v-if="this.menuItem === 6 && this.mergePrac">
                                <input type="checkbox" v-model="row.sloucit" />
                            </td>

                            <td
                                v-for="(header, j) in headerKeys"
                                :key="j"
                                :style="menuItem === 9 && header === 'gRepre' ? 'background-color: ' + row[header] : ''"
                            >
                                {{ row[header] }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div v-if="this.showMergeDiv" class="merge-div-parent">
        <div class="merge-div">
            <div style="font-weight: bold;">Vyberte pracoviště, které bude zachováno:</div>
            <table v-if="this.menuItem == 6" style="margin-top: 10px;">
                <thead>
                    <tr>
                        <th>Název</th>
                        <th>Pracoviště</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, i) in sortedRows.filter(r => r.sloucit == true)" :key="i" @click="commitMerge(row.id)">
                        <td>{{ row.nazev }}</td>
                        <td>{{ row.pracoviste }}</td>
                    </tr>
                </tbody>
            </table>
            <button @click="closeMerge" class="button-small" style="position: relative; float: right; margin-top: 10px;">Zrušit</button>
        </div>
    </div>
</template>

<script>
    import api from '@/api/api.js'
    import EditTypDOSS from './EditTypDOSS.vue'
    import EditDOSS from './EditDOSS.vue'
    import EditDOSSPrac from './EditDOSSPrac.vue'
    import EditDruhPodani from './EditDruhPodani.vue'
    import EditDruhStanoviska from './EditDruhStanoviska.vue'
    import EditStatus from './EditStatus.vue'

    export default {
        name: 'Ciselnik',
        props: ['menuItem', 'isAdmin', 'isEditor'],
        components: {
            EditTypDOSS,
            EditDOSS,
            EditDOSSPrac,
            EditDruhPodani,
            EditDruhStanoviska,
            EditStatus
        },
        data() {
            return {
                headers: {},
                rows: [],
                currentSort: '',
                currentSortDir: 'asc',
                showEdit: false,
                itemId: -1,
                mergePrac: false,
                idTypDOSS: -1,
                typDOSS: [],
                idDOSS: -1,
                doss: [],
                showMergeDiv: false
            }
        },
        computed: {
            headerKeys() {
                return Object.keys(this.headers)
            },
            sortedRows() {
                if (this.currentSort === '')
                    return this.filteredRows
                return this.filteredRows.slice().sort(
                    (a, b) => this.currentSortDir === 'desc' 
                        ? b[this.currentSort].localeCompare(a[this.currentSort], 'cz') 
                        : a[this.currentSort].localeCompare(b[this.currentSort], 'cz'))
            },
            filteredRows() {
                switch (this.menuItem) {
                    case 6:
                        if (this.idDOSS !== -1)
                            return this.rows.filter(r => r.iddoss == this.idDOSS)
                        if (this.idTypDOSS !== -1)
                            return this.rows.filter(r => r.idTypDOSS == this.idTypDOSS)
                        return this.rows
                    default:
                        return this.rows
                }
            },
            sortedTypDOSS() {
                return this.typDOSS
                    .slice()
                    .sort((a, b) => (a.kategorie).localeCompare((b.kategorie), 'cz'))
            },
            sortedDOSS() {
                return this.filteredDOSS
                    .slice()
                    .sort((a, b) => (a.nazev + ':' + a.kategorie).localeCompare((b.nazev + ':' + b.kategorie), 'cz'))
            },
            filteredDOSS() {
                if (this.idTypDOSS !== -1)
                    return this.doss.filter(d => d.idTyp == this.idTypDOSS)
                else
                    return this.doss
            }
        },
        watch: {
            menuItem(newVal, oldVal) {
                if (oldVal !== newVal) {
                    this.showEdit = false
                    this.updateTable()
                }
            }
        },
        methods: {
            load() {
                api.getTypDOSS()
                .then(response => {
                    this.typDOSS = response.data
                })
                .catch(error => {
                    console.log('Error: ', error)
                })
                api.getDOSS()
                .then(response => {
                    this.doss = response.data
                })
                .catch(error => {
                    console.log('Error: ', error)
                })
            },
            updateTable() {
                this.currentSort = ''
                this.currentSortDir = 'asc'
                
                switch (this.menuItem) {
                    case 4:
                        this.headers = { "nazev": "Název", "kategorie": "Kategorie" }
                        this.$progress.start()
                        api.getTypDOSS()
                        .then(response => {
                            this.$progress.finish()
                            this.rows = response.data
                        })
                        .catch(error => {
                            this.$progress.finish()
                            console.log('Error: ', error)
                        })
                        break
                    case 5:
                        this.headers = { "nazev": "Název", "typDOSS": "Typ DOSS" }
                        this.$progress.start()
                        api.getDOSS()
                        .then(response => {
                            this.$progress.finish()
                            this.rows = response.data
                        })
                        .catch(error => {
                            this.$progress.finish()
                            console.log('Error: ', error)
                        })
                        break
                    case 6:
                        this.headers = { "nazev": "Název", "pracoviste": "Pracoviště", "zkratka": "Zkratka", "ulice": "Ulice", "obec": "Obec", "psc": "PSČ", "idds": "IDDS" }
                        this.$progress.start()
                        api.getDOSSPrac()
                        .then(response => {
                            this.$progress.finish()
                            this.rows = response.data
                        })
                        .catch(error => {
                            this.$progress.finish()
                            console.log('Error: ', error)
                        })
                        break
                    case 7:
                        this.headers = { "druh": "Druh", "oznaceni": "Označení" }
                        this.$progress.start()
                        api.getDruhPodani()
                        .then(response => {
                            this.$progress.finish()
                            this.rows = response.data
                        })
                        .catch(error => {
                            this.$progress.finish()
                            console.log('Error: ', error)
                        })
                        break
                    case 8:
                        this.headers = { "druh": "Druh", "oznaceni": "Označení" }
                        this.$progress.start()
                        api.getDruhStanoviska()
                        .then(response => {
                            this.$progress.finish()
                            this.rows = response.data
                        })
                        .catch(error => {
                            this.$progress.finish()
                            console.log('Error: ', error)
                        })
                        break
                    case 9:
                        this.headers = { "nazev": "Název", "gRepre": "Barva" }
                        this.$progress.start()
                        api.getStatus()
                        .then(response => {
                            this.$progress.finish()
                            this.rows = response.data
                        })
                        .catch(error => {
                            this.$progress.finish()
                            console.log('Error: ', error)
                        })
                        break
                    default:
                        this.headers = {}
                }
            },
            sort(s) {
                if (s === this.currentSort) {
                    this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
                }
                else {
                    this.currentSort = s
                    this.currentSortDir = 'asc'
                }
            },
            edit(id) {
                if (!(this.menuItem === 6 && this.mergePrac)) {
                    this.itemId = id
                    this.showEdit = true
                }
            },
            closeEdit() {
                this.showEdit = false
                this.itemId = -1
            },
            exportTable() {
                switch (this.menuItem) {
                    case 4:
                        window.open(process.env.VUE_APP_API_URL + '/export/typdoss')
                        break;
                    case 5:
                        window.open(process.env.VUE_APP_API_URL + '/export/doss')
                        break;
                    case 6:
                        window.open(process.env.VUE_APP_API_URL + '/export/dossprac')
                        break;
                    case 7:
                        window.open(process.env.VUE_APP_API_URL + '/export/druhpodani')
                        break;
                    case 8:
                        window.open(process.env.VUE_APP_API_URL + '/export/druhstanoviska')
                        break;
                    case 9:
                        window.open(process.env.VUE_APP_API_URL + '/export/status')
                        break;
                }
            },
            mergePracoviste() {
                this.mergePrac = !this.mergePrac
            },
            showMerge() {
                if (this.filteredRows.filter(r => r.sloucit == true).length < 2) {
                    alert('Vyberte minimálně dvě pracoviště.')
                    return
                }
                let groups = this.filteredRows.filter(r => r.sloucit == true).reduce((acc, value) => {
                    if (!acc[value.iddoss])
                        acc[value.iddoss] = []
                    return acc
                }, {})
                if (Object.keys(groups).length > 1) {
                    alert('Vyberte pracoviště pouze z jedné instituce.')
                    return
                }
                this.showMergeDiv = true
            },
            closeMerge() {
                this.showMergeDiv = false
            },
            commitMerge(id) {
                let ids = this.filteredRows.filter(r => r.sloucit == true && r.id != id).map(r => r.id).join(',')
                
                this.$progress.start()
                api.mergeDOSSPrac(id, ids)
                .then(() => {
                    this.$progress.finish()
                    this.closeMerge()
                    this.updateTable()
                    alert('Pracoviště byla úspěšně sloučena.')
                })
                .catch(error => {
                    this.$progress.finish()
                    console.log('Error: ', error)
                    this.closeMerge()
                    this.updateTable()
                    alert('Během slučování pracovišť nastala chyba: ' + error)
                })
            }
        },
        created() {
            this.showEdit = false
            this.load()
            this.updateTable()
        }
    }
</script>